import { FormControl, FormHelperText, FormLabel, IconButton, InputAdornment, TextField } from '@mui/material';
import { Component } from 'react';
import { BsInfoCircle } from "react-icons/bs";
import { MdVisibility, MdVisibilityOff } from 'react-icons/md';

export default class SenhaInput extends Component {

    constructor(props) {
        super(props)
        this.state = {
            showPassword: false,
        }
    }

    render() {
        return (
            <TextField
                error={this.props.error === true}
                helperText={this.props.error === true ? "Informe a senha" : null}
                size="small"
                variant="outlined"
                name="senha"
                label="Senha"
                value={this.props.value}
                onChange={e => this.props.onChange ? this.props.onChange(e.target.value) : {}}
                type={this.state.showPassword ? 'text' : 'password'}
                InputProps={{
                    endAdornment:
                        <InputAdornment position="end">
                            <IconButton onClick={e => this.setState({ showPassword: !this.state.showPassword })}>
                                {this.state.showPassword ? <MdVisibilityOff /> : <MdVisibility />}
                            </IconButton>
                        </InputAdornment>
                }}
            />
        );
    }
}